import React from 'react';
import PropTypes from 'prop-types';
import validator from 'validator';
import ValidationMessage from './ValidationMessage';

class PhoneValidation extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isInvalid: false };
  }

  componentDidMount() {
    this.validate();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.validate();
    }
  }

  componentWillUnmount() {
    // Whenever the component is unmount then it needs to let the parent know.
    if (this.props.onValidated) {
      this.props.onValidated(false, null);
    }
  }

  getDefaultMessage() {
    const defaultMessage = (<ValidationMessage controlName={this.props.controlLabel} message=" does not have the right US phone number format." />);
    const message = this.props.children || defaultMessage;
    return message;
  }

  validate() {
    const isInvalid = !validator.isEmpty(this.props.value) &&
      ((!this.props.allowInternational && !validator.isMobilePhone(this.props.value, 'en-US')) || (this.props.allowInternational && !validator.isMobilePhone(this.props.value, 'any')));
    const message = this.getDefaultMessage();
    const isCritical = this.props.isCritical;

    this.setState({ isInvalid });

    if (this.props.onValidated) {
      this.props.onValidated(isInvalid, message);
    }
    return { isInvalid, message, isCritical };
  }

  render() {
    if (this.props.displayInSummary || !this.state.isInvalid) {
      return null;
    }
    const message = this.getDefaultMessage();
    return (message);
  }
}

PhoneValidation.defaultProps = {
  children: null,
  displayInSummary: false,
  isCritical: false,
  allowInternational: false
};

PhoneValidation.propTypes = {
  controlLabel: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  displayInSummary: PropTypes.bool,
  isCritical: PropTypes.bool,
  children: PropTypes.element,
  onValidated: PropTypes.func,
  allowInternational: PropTypes.bool
};

export default PhoneValidation;
